import { render } from "./PvpCarDetailPage.vue?vue&type=template&id=910495b2&scoped=true"
import script from "./PvpCarDetailPage.vue?vue&type=script&lang=ts"
export * from "./PvpCarDetailPage.vue?vue&type=script&lang=ts"

import "./PvpCarDetailPage.vue?vue&type=style&index=0&id=910495b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-910495b2"

export default script